import { render, staticRenderFns } from "./FormCurrent.vue?vue&type=template&id=fac74ec6&scoped=true&"
import script from "./FormCurrent.vue?vue&type=script&lang=js&"
export * from "./FormCurrent.vue?vue&type=script&lang=js&"
import style0 from "./FormCurrent.vue?vue&type=style&index=0&id=fac74ec6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac74ec6",
  null
  
)

export default component.exports